import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { predefinedDiscoverCollectionsBackend } from './predefined-discover-collections.backend';
import { predefinedDiscoverCollectionsReducer } from './predefined-discover-collections.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'predefinedDiscoverCollections',
      predefinedDiscoverCollectionsReducer,
    ),
    BackendModule.forFeature(
      'predefinedDiscoverCollections',
      predefinedDiscoverCollectionsBackend,
    ),
  ],
})
export class DatastorePredefinedDiscoverCollectionsModule {}
